import {createContext, useContext} from 'react';

/**
 * Whether the flowchart is being edited. Connection-drawing affordances only show while editing.
 * Defaults to false so any render outside the editor hides them.
 */
export const ProcedureRunDesignFlowchartEditableContext = createContext<boolean>(false);

/** Reads whether the flowchart is currently editable. */
export function useProcedureRunDesignFlowchartIsEditable(): boolean {
  return useContext(ProcedureRunDesignFlowchartEditableContext);
}
